import { Box, Link, Paper, Typography } from '@mui/material';
import { LocalContext } from 'Context/Local.context';
import useTranslate from 'Hooks/useTranslate';
import { useContext, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PaperTitle } from 'Theme/components';
import { OrganizationInviteNotifyModal } from './OrganizationInviteNotifyModal';

function OrganizationInvite() {
  const ts = useTranslate();
  const { accountCode } = useParams<IUriParams>();
  const { availableAccounts } = useContext(LocalContext);

  /**
   * Hors route `…/all`, le segment d’URL est le code compte. Sur `all`, ce bloc n’est affiché
   * que lorsqu’un seul compte est administré (`PageDashboard` / `displayOrganizationInvite`) :
   * on prend alors `availableAccounts[0]`.
   */
  const effectiveAccountCode = useMemo(() => {
    if (accountCode !== 'all') {
      return accountCode;
    }
    return availableAccounts[0]?.code ?? '';
  }, [accountCode, availableAccounts]);

  const [open, setOpen] = useState(false);

  return (
    <Paper>
      <PaperTitle
        variant="subtitle1"
        title={ts('page.dashBoard.organizationInvite.title')}
      />
      <Box p={2} display="flex" flexDirection="column" gap={1}>
        <Typography paragraph>
          {ts('page.dashBoard.organizationInvite.description1')}
        </Typography>
        <Typography paragraph>
          {ts('page.dashBoard.organizationInvite.description2')}
        </Typography>
        <Typography paragraph>
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={() => {
              if (!effectiveAccountCode) {
                return;
              }
              setOpen(true);
            }}
            sx={{ verticalAlign: 'baseline' }}
          >
            {ts('page.dashBoard.organizationInvite.description3')}
          </Link>{' '}
          {ts('page.dashBoard.organizationInvite.description4')}
        </Typography>
      </Box>

      <OrganizationInviteNotifyModal
        open={open}
        onClose={() => setOpen(false)}
        accountCode={effectiveAccountCode}
      />
    </Paper>
  );
}

export default OrganizationInvite;
